import React, { useEffect, useState } from 'react';
import './Hero.css';
import bgImage from '../assets/hero-bg.png';
import logo from '../assets/logo.png';

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      className="hero"
      id="home"
    >
      {/* Parallax background image */}
      <div
        className="hero-bg-image"
        style={{
          backgroundImage: `url(${bgImage})`,
          transform: `translateY(${scrollY * 0.5}px)`,
        }}
      />

      {/* Gradient overlay */}
      <div className="hero-gradient-overlay" />

      {/* Logo at the top */}
      <div className="hero-logo">
        <img src={logo} alt="Asif Chemicals Logo" />
      </div>

      {/* Content - positioned below engraved text */}
      <div
        className="hero-content"
        style={{ transform: `translateY(${scrollY * 0.3}px)` }}
      >
        <h1 className="hero-title">
          <span className="hero-title-brand">SILVERSTONES</span>
        </h1>

        <p className="hero-subtitle">Your Global Partner in Premium Industrial Minerals</p>
        <div className="hero-cta">
          <button
            className="hero-btn hero-btn-primary"
            onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
          >
            Products
          </button>
          <button
            className="hero-btn hero-btn-secondary"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Animated scroll indicator */}
      <div className="scroll-indicator">
        <span></span>
      </div>
    </section>
  );
};

export default HeroSection;
